function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import ButtonRB from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
const Button = /*#__PURE__*/forwardRef(({
  removeTextWhenLoading,
  loading,
  children,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(ButtonRB, _extends({
    ref: ref,
    disabled: loading
  }, props), loading && removeTextWhenLoading ? null : children, loading && /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    className: removeTextWhenLoading ? undefined : "ml-3",
    size: "sm"
  }));
});
export default Button;